import React from "react"
import PropTypes from "prop-types"

import { ZoomInIcon, ZoomOutIcon, DownloadIcon, CloseIcon, RotateIcon } from "./icons"

function isSameOrigin(href) {
  // @ts-ignore
  return document.location.hostname !== new URL(href, document.location).hostname
}

/**
 * Triggers image download from cross origin URLs
 *
 * `<a href="..." download>foo</a> works only for same-origin URLs.
 * Further info: https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#attr-download
 */
const crossOriginDownload = (href) => (event) => {
  event.preventDefault() // Impede o comportamento padrão do link

  // Cria um nome de arquivo padrão se não houver um na URL
  const filename = href.split("/").pop() || "download.jpg"

  // Tenta fazer o download via fetch (ignora CORS usando 'no-cors', mas pode não funcionar para imagens protegidas)
  fetch(href, { mode: "no-cors" })
    .then((res) => {
      if (!res.ok && res.type !== "opaque") {
        // 'opaque' é o modo 'no-cors' para respostas CORS
        throw new Error("Não foi possível baixar a imagem.")
      }
      return res.blob()
    })
    .then((blob) => {
      const blobUrl = URL.createObjectURL(blob)
      const a = document.createElement("a")
      a.href = blobUrl
      a.download = filename
      document.body.appendChild(a)
      a.click()

      // Limpeza
      setTimeout(() => {
        document.body.removeChild(a)
        URL.revokeObjectURL(blobUrl)
      }, 100)
    })
    .catch(() => {
      // Fallback: Abre a imagem em uma nova aba se o fetch falhar
      window.open(href, "_blank")
    })
}

const Header = ({
  image,
  alt,
  zoomed,
  toggleZoom,
  toggleRotate,
  onClose,
  enableDownload,
  enableZoom,
  enableRotate,
}) => (
  <div className="__react_modal_image__header">
    <span className="__react_modal_image__icon_menu">
      {enableDownload && (
        <a target="_blank" rel="noreferrer" href={image} download>
          <DownloadIcon />
        </a>
      )}
      {enableZoom && <a onClick={toggleZoom}>{zoomed ? <ZoomOutIcon /> : <ZoomInIcon />}</a>}
      {enableRotate && (
        <a onClick={toggleRotate}>
          <RotateIcon />
        </a>
      )}
      <a onClick={onClose}>
        <CloseIcon />
      </a>
    </span>
    {alt && <span className="__react_modal_image__caption">{alt}</span>}
  </div>
)

export default Header

Header.propTypes = {
  image: PropTypes.string.isRequired,
  alt: PropTypes.string,
  zoomed: PropTypes.bool.isRequired,
  toggleZoom: PropTypes.func.isRequired,
  toggleRotate: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  enableDownload: PropTypes.bool,
  enableZoom: PropTypes.bool,
  enableRotate: PropTypes.bool,
}
